import { ActionPragmaticInfo } from '@app/enums/pragmatic-info.enum';
import { PragmaticChapterDetail } from '@app/interface/pragmatic-chapter-detail';
import { PragmaticProfile } from '@app/interface/pragmatic.profile';
import { ChapterDetailsData } from '@app/interface/user-info';
import { createAction, props } from '@ngrx/store';

/* ============================================================
   USUARIO LOGUEADO
============================================================ */
export const loadPragmaticLogedUser = createAction(
  ActionPragmaticInfo.LOAD_PRAGMATIC_LOGED_USER,
  props<{ email: string }>()
);

export const loadPragmaticLogedUserSuccessfully = createAction(
  ActionPragmaticInfo.LOAD_PRAGMATIC_LOGED_USER_SUCCESSFULLY,
  props<{ pragmaticLogedUser: PragmaticProfile }>()
);

export const loadPragmaticLogedUserFailure = createAction(
  ActionPragmaticInfo.LOAD_PRAGMATIC_LOGED_USER_FAILURE
);

/* ============================================================
   PERFIL (ID > EMAIL) – RETROCOMPATIBLE
============================================================ */
export const loadPragmaticProfile = createAction(
  '[PragmaticInfo] Load Pragmatic Profile',
  props<{ pragmaticId?: number; email?: string }>()
);

export const loadPragmaticProfileSuccess = createAction(
  ActionPragmaticInfo.LOAD_PRAGMATIC_PROFILE_SUCCESSFULLY,
  props<{ pragmaticProfile: PragmaticProfile }>()
);

export const loadPragmaticProfileFailure = createAction(
  ActionPragmaticInfo.LOAD_PRAGMATIC_PROFILE_FAILURE
);

/* ============================================================
   CHAPTER DETAILS (ID > EMAIL) – RETROCOMPATIBLE
============================================================ */
export const loadPragmaticChapterDetails = createAction(
  '[PragmaticInfo] Load Pragmatic Chapter Details',
  props<{ pragmaticId?: number; email?: string }>()
);

export const loadPragmaticChapterDetailsSuccess = createAction(
  ActionPragmaticInfo.LOAD_PRAGMATIC_CHAPTER_DETAILS_SUCCESSFULLY,
  props<{ pragmaticChapterDetails: PragmaticChapterDetail[] }>()
);

export const loadPragmaticChapterDetailsFailure = createAction(
  '[PragmaticInfo] Load Pragmatic Chapter Details Failure'
);

/* ============================================================
   CURRENT CHAPTER
============================================================ */
export const loadCurrentChapterDetails = createAction(
  ActionPragmaticInfo.LOAD_PRAGMATIC_CURRENT_CHAPTER_DETAILS,
  props<{ currentChapterDetails: ChapterDetailsData }>()
);

/* ============================================================
   RESET PRAGMATIC PROFILE STATE
============================================================ */
export const resetPragmaticProfileState = createAction(
  '[PragmaticInfo] Reset Pragmatic Profile State'
);
